import axios from 'axios'
import {BASE_URL} from './ConnectionConfig'
import HandleRequestError from './HandleRequestError'

let axiosUnAuth = axios.create({
  baseURL: BASE_URL
})

axiosUnAuth.interceptors.response.use(response => response, err => HandleRequestError(err))

export default axiosUnAuth



// WEBPACK FOOTER //
// ./src/communication/UnAuthConnection.js